import { MtHttpError } from './HttpError';
var Http = /** @class */ (function () {
    function Http() {
    }
    Http.createError = function (message, xhr) {
        var error = new MtHttpError(message);
        error.status = xhr.status;
        error.statusText = xhr.statusText;
        return error;
    };
    Http.get = function (url) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 400) {
                    resolve(xhr.response);
                }
                else {
                    reject(Http.createError('Failed to get ' + url, xhr));
                }
            };
            xhr.onerror = function () {
                reject(Http.createError('Failed to get ' + url, xhr));
            };
            xhr.send();
        });
    };
    return Http;
}());
export { Http };
//# sourceMappingURL=index.js.map